// extracted by mini-css-extract-plugin
var _1 = "tjs-guide__body";
var _2 = "tjs-guide__bodyFooter";
var _3 = "tjs-guide__bodyProgress";
var _4 = "tjs-guide__btn tjs-_buttons__btn tjs-_buttons__btn-primary";
var _5 = "tjs-guide__btn--tertiary tjs-_buttons__btn--tertiary";
var _6 = "tjs-guide__btn-next";
var _7 = "tjs-guide__btn-next";
var _8 = "tjs-guide__btn--tertiary tjs-_buttons__btn--tertiary";
var _9 = "tjs-guide__guide";
var _a = "tjs-guide__image";
var _b = "tjs-guide__image-wrapper";
var _c = "tjs-guide__image-wrapper";
var _d = "tjs-guide__indicator";
var _e = "tjs-guide__indicatorEnabled";
var _f = "tjs-guide__indicatorWrapper";
var _10 = "tjs-guide__inner-close-btn tjs-_buttons__btn";
var _11 = "tjs-guide__inner-close-btn tjs-_buttons__btn";
export { _1 as "body", _2 as "bodyFooter", _3 as "bodyProgress", _4 as "btn", _5 as "btn--tertiary", _6 as "btn-next", _7 as "btnNext", _8 as "btnTertiary", _9 as "guide", _a as "image", _b as "image-wrapper", _c as "imageWrapper", _d as "indicator", _e as "indicatorEnabled", _f as "indicatorWrapper", _10 as "inner-close-btn", _11 as "innerCloseBtn" }
export default { "body": _1, "bodyFooter": _2, "bodyProgress": _3, "btn": _4, "btn--tertiary": _5, "btn-next": _6, "btnNext": _7, "btnTertiary": _8, "guide": _9, "image": _a, "image-wrapper": _b, "imageWrapper": _c, "indicator": _d, "indicatorEnabled": _e, "indicatorWrapper": _f, "inner-close-btn": _10, "innerCloseBtn": _11 }
